import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import deviceStoreModule from '@/views/devices/deviceStoreModule'
import userStoreModule from '@/views/users/userStoreModule'
import alertConfigStoreModule from '@/views/alerts/config/alertConfigStoreModule'
import alertHistoryStoreModule from '@/views/alerts/history/alertHistoryStoreModule'
import orgStoreModule from '@/views/organizations/orgStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    devices: deviceStoreModule,
    users: userStoreModule,
    alertConfig: alertConfigStoreModule,
    alertHistory: alertHistoryStoreModule,
    orgs: orgStoreModule,
  },
  strict: process.env.DEV,
})
